module.exports = __webpack_public_path__ + "img/waiting.f9498909.png";